import React, { PureComponent } from 'react'
import {getList, setSessionData, getSessionData, delSessionData} from '../../../api/school'
import NoResult from '../../../components/NoResult'
import Search from '../../../components/Search'
import { TYPE_COLLEGE, TYPE_UNDERGRADUATE } from '../../Major/constants'
import { LIMIT } from '../constants'
import Filters from './Filters'
import './index.less'

const paramReset = {
  limit: LIMIT,
  page: 1,
  _s_name: null,
  _s_province_id: null,
  _s_city_id: null,
  _s_memberof: null,
  _s_is_985: null,
  _s_is_211: null,
  _s_tag_double_top:null,
}

class SchoolList extends PureComponent {

  state = {
    schoolList: [],
    resultList: [],
    searchVal: '',
    param: paramReset,
    searchParam: paramReset,
    filter: null,
    showFilter: false,
    loading: false,
  }

  searchThrottle = null

  refSearch = null

  refSchoolList = null

  _handleScroll = this.handleScroll.bind(this)
  componentDidMount() {
      const { param,searchParam } = this.state;
      if(getSessionData('currentPage') && getSessionData('schoolId') && getSessionData('schoolList')){
          if(getSessionData('searchVal')){
              this.setState({
                  resultList: getSessionData('schoolList'),
                  searchParam:{
                      ...searchParam,
                      page: getSessionData('currentPage'),
                      _s_name: getSessionData('searchVal'),
                  },
                  searchVal:getSessionData('searchVal')
              },()=>{
                  let className=getSessionData('schoolId');
                  let schoolItem=document.getElementsByClassName(className)[0];
                  this.refSchoolList.scrollTo(0,schoolItem.offsetTop-100);
              })
          }else if(getSessionData('filter')){
              this.setFilterColor(getSessionData('filter'));
              this.setState({
                  schoolList: getSessionData('schoolList'),
                  param:{
                      ...param,
                      page: getSessionData('currentPage'),
                      ...getSessionData('filter')
                  },
              },()=>{
                  let className=getSessionData('schoolId');
                  let schoolItem=document.getElementsByClassName(className)[0];
                  this.refSchoolList.scrollTo(0,schoolItem.offsetTop-100);
              })
          }else {
              this.setState({
                  schoolList: getSessionData('schoolList'),
                  param:{
                      ...param,
                      page: getSessionData('currentPage'),
                  },
              },()=>{
                  let className=getSessionData('schoolId');
                  let schoolItem=document.getElementsByClassName(className)[0];
                  this.refSchoolList.scrollTo(0,schoolItem.offsetTop-100);
              })
          }
      }else {
          this.getSchoolList(param, res => {
              this.setState({
                  schoolList: res.data,
                  lastPage: res.lastPage,
              })
          })
      }
      this.refSchoolList.addEventListener('scroll', this._handleScroll, true)
  }

    componentWillUnmount() {
        delSessionData('currentPage');
        delSessionData('schoolId');
        delSessionData('schoolList');
        this.refSchoolList.removeEventListener('scroll', this._handleScroll, true)
    }

  handleScroll() {
    // 滚动到底
    const list = this.refSchoolList
    if (list.scrollHeight-list.clientHeight - list.scrollTop <10 ) {
      this.onLoadMore()
    }
  }

  onLoadMore() {
    const { searchVal, param, searchParam, schoolList, resultList, loading, lastPage } = this.state
    const newParam = {
      ...(searchVal ? searchParam : param),
      page: searchVal ? searchParam.page +1: param.page + 1,
    }
    if (!loading && !lastPage) {
      this.getSchoolList(newParam, res => {
        const state = {
          lastPage: res.lastPage,
          param: newParam,
          searchParam:newParam
        }
        if (searchVal) {
          state.resultList = [...resultList, ...res.data]
        } else {
          state.schoolList = [...schoolList, ...res.data]
        }
        this.setState(state)
      })
    }
  }

  handleCollegeClick(college,type) {
    const { history } = this.props;
    let {param,schoolList,resultList,searchVal,searchParam,filter}=this.state;
      if(this.props.rightIcon){
          if(type==='schoolList'){
              history.push({
                  pathname:`/schoolwishlist/school/${college.id}`,
                  state:{
                      currentPage:param.page,
                      schoolId:college.id,
                      schoolList:schoolList,
                      filter:filter
                  }});
          }else{
              history.push({
                  pathname:`/schoolwishlist/school/${college.id}`,
                  state:{
                      currentPage:searchParam.page,
                      schoolId:college.id,
                      schoolList:resultList,
                      searchVal:searchVal
                  }});
          }
      }else {
          if(type==='schoolList'){
              history.push({
                  pathname:`/school/detail/${college.id}`,
                  state:{
                      currentPage:param.page,
                      schoolId:college.id,
                      schoolList:schoolList,
                      filter:filter
                  }});
          }else{
              history.push({
                  pathname:`/school/detail/${college.id}`,
                  state:{
                      currentPage:searchParam.page,
                      schoolId:college.id,
                      schoolList:resultList,
                      searchVal:searchVal
                  }});
          }
      }
  }

  handleSearch(value) {
      this.refSchoolList.scrollTo(0,0);
      if (value) {
        const param = {
            ...paramReset,
            _s_name: value,
        };
        this.setState({
            searchParam: param,
        });
        this.getSchoolList(param, res => {
            this.setState({
                resultList: res.data,
                lastPage: res.lastPage,
            })
        })
    }else {
        const param = {
            ...paramReset
        };
        this.setState({
            param: param,
        });
        this.getSchoolList(param, res => {
            this.setState({
                schoolList: res.data,
                lastPage: res.lastPage,
            })
        })
    }
    this.setState({
      searchVal: value,
    })
  }

  getSchoolList(param, fn) {
    this.setState({
      loading: true,
    })
    getList(param)
      .then(fn)
      .finally(() => {
        this.setState({
          loading: false,
        })
      })
  }

    showFilter(name){
        if(name=='level'){
            this.setState({
                showLevelFilter: !this.state.showLevelFilter,
                showProvinceFilter:false,
                showCategoryFilter:false,
            })
        }else if(name=='province'){
            this.setState({
                showLevelFilter:false,
                showProvinceFilter:!this.state.showProvinceFilter,
                showCategoryFilter:false,
            })
        }else if(name=='category'){
            this.setState({
                showLevelFilter: false,
                showProvinceFilter:false,
                showCategoryFilter:!this.state.showCategoryFilter,
            })
        }
        this.setState({filterItem:name,})
    }

    handleFilter(filter) {
        const param = {
            ...paramReset,
            ...(filter || {}),
        }
        this.setState({
            param,
            filter,
        });
        this.setFilterColor(filter);
        this.getSchoolList(param, res => {
            this.setState({
                schoolList: res.data,
                lastPage: res.lastPage,
                showCategoryFilter: false,
                showProvinceFilter: false,
                showLevelFilter: false,
            })
        });
        Object.keys(filter).forEach(i=>{
            setSessionData(i,filter[i]);
        });
        this.refSchoolList.scrollTo(0,0);
    }

  handleHideFilter() {
      this.setState({
          showCategoryFilter: false,
          showProvinceFilter: false,
          showLevelFilter: false,
      })
  }
  setFilterColor(filter){
      if(filter._s_type||filter._s_tag_double_top||filter._s_tag_985||filter._s_tag_211 ||filter._s_memberof){
          this.setState({filterLevelBold:true})
      }
      if(filter._s_category_id__in){
          this.setState({filterCategoryBold:true})
      }
      if(filter._s_province_id__in){
          this.setState({filterProvinceBold:true})
      }
      if(!filter._s_type&&!filter._s_tag_double_top&&!filter._s_tag_985&&!filter._s_tag_211&&!filter._s_memberof){
          this.setState({filterLevelBold:false})
      }
      if(!filter._s_category_id__in){
          this.setState({filterCategoryBold:false})
      }
      if(!filter._s_province_id__in){
          this.setState({filterProvinceBold:false})
      }
  }
  renderSchoolList() {
    const { schoolList } = this.state
    return (
      <ul className="school-list">
        {this.renderList(schoolList,'schoolList')}
      </ul>
    )
  }

  renderSearchResult() {
    const { resultList, loading } = this.state
    if (Array.isArray(resultList) && resultList.length) {
      return (
        <ul className="search-result">
          {this.renderList(resultList,'resultList')}
        </ul>
      )
    } else {
      if (!loading) {
        return (
          <NoResult
            prompt2="没有匹配到合适的院校哦"
            resetBtnText="重新搜索"
            onResetSearch={() => this.refSearch.reset()} />
        )
      } else {
        return <ul className="school-list"></ul>
      }
    }
  }

  renderList(list,type) {
    const { loading, lastPage } = this.state;
    let {rightIcon}=this.props;
    if (Array.isArray(list) && list.length) {
      const lis = list.map((d, i) => (
        <li key={i} onClick={this.handleCollegeClick.bind(this, d,type)} className={d.id}>
          <div className="school-logo" style={{ backgroundImage: `url(${d.logoUrl})` }}></div>
          <div className="school-info">
            <div className="school-info-inner">
              <div className="school-info-inner-left">
                <h5>{d.name}</h5>
                <p>{d.cityName}/{d.category.name}大学</p>
                <p>
                    {d.is985 && <label className="tag-985">985</label>}
                    {d.is211 && <label className="tag-211">211</label>}
                    {d.isDoubleTop && <label className="tag-doubleTop">双一流</label>}
                </p>
              </div>
              {rightIcon ? rightIcon(d) : null}
            </div>
          </div>
        </li>
      ))
      if (loading) {
        lis.push(
          <li key="-2" className="load-more">正在加载...</li>
        )
      } else {
        if (lastPage) {
          lis.push(
            <li key="-1" className="load-more">已加载所有结果</li>
          )
        } else {
          lis.push(
            <li key="-1" className="load-more">继续下拉查看更多院校...</li>
          )
        }
      }
      return lis
    }
    if (!list.length && !loading) {
      return <li key="-3" className="load-more">没有匹配到合适的院校哦</li>
    }
  }

  renderEmptyResult() {
    return (
      <div className="no-result">
        <div>
          <p>对不起</p>
          <p>没有匹配到合适的院校哦</p>
        </div>
        <button className="primary">重新搜索</button>
      </div>
    )
  }

  renderFilter() {
        const {showCategoryFilter,showProvinceFilter,showLevelFilter,filterLevelBold,filterCategoryBold,filterProvinceBold} = this.state;
        return (
            <div className="school-filter" >
                <div className={`btn-expand-filter ${filterLevelBold&&'filter-bold'}`} onClick={this.showFilter.bind(this,'level')}>
                    <span>层次</span>
                    {showLevelFilter?
                        <svg t="1578450043031" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3559" width="200" height="200"><path d="M512 320 128 736 896 736Z" p-id="3560" fill={filterLevelBold?"#334cd5":"#4a4a4a"}></path></svg>
                        :
                        <svg t="1578397685477" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1112" width="200" height="200"><path d="M512 736 128 320 896 320Z" p-id="1113" fill={filterLevelBold?"#334cd5":"#4a4a4a"}></path></svg>}
                </div>
                <div className={`btn-expand-filter ${filterProvinceBold&&'filter-bold'}`} onClick={this.showFilter.bind(this,'province')} >
                    <span>地域</span>
                    {showProvinceFilter?
                        <svg t="1578450043031" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3559" width="200" height="200"><path d="M512 320 128 736 896 736Z" p-id="3560" fill={filterProvinceBold?"#334cd5":"#4a4a4a"}></path></svg>
                        :
                        <svg t="1578397685477" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1112" width="200" height="200"><path d="M512 736 128 320 896 320Z" p-id="1113" fill={filterProvinceBold?"#334cd5":"#4a4a4a"}></path></svg>}
                </div>
                <div className={`btn-expand-filter ${filterCategoryBold&&'filter-bold'}`} onClick={this.showFilter.bind(this,'category')} >
                    <span>类别</span>
                    {showCategoryFilter?
                        <svg t="1578450043031" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3559" width="200" height="200"><path d="M512 320 128 736 896 736Z" p-id="3560" fill={filterCategoryBold?"#334cd5":"#4a4a4a"}></path></svg>
                        :
                        <svg t="1578397685477" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1112" width="200" height="200"><path d="M512 736 128 320 896 320Z" p-id="1113" fill={filterCategoryBold?"#334cd5":"#4a4a4a"}></path></svg>}
                </div>

            </div>
        )
    }

    renderFilterPop() {
        const {showProvinceFilter,showCategoryFilter,showLevelFilter,filterItem} = this.state;
        if(showProvinceFilter||showCategoryFilter||showLevelFilter){
            return (
                <div className="filter-pop-mask" onClick={this.handleHideFilter.bind(this)}>
                    <Filters onHide={this.handleHideFilter.bind(this)}
                             onFilter={this.handleFilter.bind(this)}
                             filterItem={filterItem}
                    />
                </div>
            )
        }else {
            return(
                <div></div>
            )
        }
    }

  render() {
    const { searchVal, showFilter } = this.state;
      return (
      <div className="school-list-wrapper">
        <Search
          ref={ref => this.refSearch = ref}
          placeholder="搜索你想了解的学校"
          onSearch={this.handleSearch.bind(this)}
          value={searchVal}
        />
          {!searchVal&&this.renderFilter()}
           {/*筛选条件展开 ↓*/}
          {this.renderFilterPop()}
        <div
          className={'school-list-outter ' + (showFilter ? 'show-filter' : '')}
          ref={ref => this.refSchoolList = ref}>
          {searchVal
            ? <div className="result-title">搜索结果</div>
            : <div></div>
          }
          {searchVal
            ? this.renderSearchResult()
            : this.renderSchoolList()
          }
        </div>
      </div>
    )
  }
}

export default SchoolList



// WEBPACK FOOTER //
// ./src/pages/School/List/index.js